<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
.footer-text {
  font-family: "Prompt", sans-serif;
  font-size: 16px;
  margin-left: 25rem;
}
</style>

<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        ค้นหา ตช.
      </div>
      <v-spacer></v-spacer>

      <v-btn
        class="mr-2"
        color="primary"
        elevation="0"
        dark
        @click="linktoPublic()"
      >
        <v-icon left dark> mdi-share </v-icon>ลิงค์รายงาน
      </v-btn>

      <v-btn
        class="mr-2"
        color="success"
        elevation="0"
        dark
        @click="reportPDF()"
      >
        <v-icon left>mdi-magnify</v-icon>ส่งรายงาน ตช.
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <div class="d-flex justify-space-around">
      <div class="mt-5" style="width: 40px">วันที่</div>
      <div>
        <date-picker
          class="mt-3"
          color="black"
          :format="momentFormat"
          style="width: 100%"
          v-model="search_dates"
          range
        ></date-picker>
      </div>
      <div>
        <v-select
          style="width: 100px"
          :items="carItem"
          label="รถทุกคัน"
          v-model="search_car"
          item-text="CAR_NUMBER"
          :item-value="carItem"
          return-object
        ></v-select>
      </div>
      <div>
        <v-combobox
          style="max-width: 250px; width: 100%"
          v-model="search_name"
          label="ชื่อสถานบริการ"
          :items="search_wastName"
          item-text="CUSTOMER_NAME"
          item-value="CUSTOMER_NAME"
          return-object
        ></v-combobox>
      </div>
      <div>
        <v-text-field
          v-model="search_wastID"
          label="เลขที่เอกสาร ตช."
        ></v-text-field>
      </div>
      <div>
        <v-btn
          class="mr-2 mt-5"
          color="error"
          elevation="0"
          dark
          @click="clear_search()"
        >
          <v-icon left>mdi-magnify</v-icon>ล้าง
        </v-btn>
        <v-btn
          class="mt-5"
          color="success"
          elevation="0"
          dark
          @click="search_search()"
        >
          <v-icon left>mdi-magnify</v-icon>ค้นหา
        </v-btn>
      </div>
    </div>

    <!--
    <v-row>
      <v-col cols="12" md="1" class="text-center py-0 mx-0">
        <div class="mt-5">วันที่</div>
      </v-col>
      <v-col cols="12" md="3" class="text-center py-0 mt-2 mx-0">
        <date-picker
          color="black"
          class="mb-1"
          :format="momentFormat"
          style="width: 100%"
          v-model="search_dates"
          range
        ></date-picker>
      </v-col>
      <v-col cols="12" md="1" class="py-0">
        <v-select
          :items="items"
          label="รถทุกคัน"
          v-model="search_car"
          item-text="CAR_NUMBER"
          item-value="CAR_NUMBER"
        ></v-select>
      </v-col>
      <v-col cols="12" md="2" class="py-0 mr-0 pr-0">
        <v-text-field
          v-model="search_wastID"
          placeholder="เลขที่เอกสาร ตช."
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="3" class="text-center py-0 px-0 mt-2">
        <v-btn
          class="mr-2"
          color="success"
          elevation="0"
          dark
          @click="clear_search()"
        >
          <v-icon left>mdi-magnify</v-icon>ล้าง
        </v-btn>
        <v-btn color="success" elevation="0" dark @click="search_search()">
          <v-icon left>mdi-magnify</v-icon>ค้นหา
        </v-btn>
      </v-col>
    </v-row>
-->
    <v-data-table
      :headers="headers"
      :items="getindex_wasteDocument"
      :search="search.CUSTOMER_NAME"
      sort-by="calories"
      class="elevation-1 enlarge-font"
      @click:row="goLinkReportDoc"
    >
      <template v-slot:footer>
        <v-divider class="my-2"></v-divider>

        <td>
          <div class="footer-text">รวม</div>
        </td>
        <td>
          <div class="footer-text">{{ sumField("W_W") | delimeter }}</div>
        </td>
      </template>
      <template v-slot:item.print="{ item }">
        <v-btn color="success" small class="mb-0" @click="print_contract(item)">
          <v-icon>mdi-printer</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.edit="{ item }">
        <v-btn
          color="info"
          small
          class="mb-0 font-weight-bold"
          @click="view_document(item)"
        >
          <v-icon left>mdi-file-document-outline</v-icon>แสดง
        </v-btn>
      </template>
      <template v-slot:item.Time="{ item }"> {{ timeTH(item.W_I) }} </template>
      <template v-slot:[`item.actions`]="{ item }">
        <TableMenuCustomer
          :TableData="item"
          :whichPage="'waste_Doc'"
          ref="wasteDoc"
        ></TableMenuCustomer>
      </template>
      <template v-slot:item.CONTRACT_START_DATE="{ item }">{{
        contract_expier(item.CONTRACT_START_DATE, item.CONTRACT_END_DATE)
      }}</template>
      <template v-slot:item.CONTRACT_END_DATE="{ item }">{{
        item.CONTRACT_END_DATE | thdate
      }}</template>
      <template v-slot:no-data>
        <v-btn color="info" @click="initialize">
          <v-icon left>mdi-refresh</v-icon>รีเฟรชข้อมูล
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import pdfMake from "@/assets/build/pdfmake";
import pdfFonts from "@/assets/build/vfs_fonts";
import waste_document from "../pdf/WasteDocument";
import print_document from "../pdf/printWastDoc";
import WwasteReportPDF from "../pdf/WwasteReportPDF";
import moment from "moment";
import QrcodeVue from "qrcode.vue";
import TableMenuCustomer from "../../components/TableMenuCustomer";

export default {
  components: {
    TableMenuCustomer,
    QrcodeVue,
  },
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    pagination: {
      sortBy: "name",
    },
    labels: "",
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date).add(543, "year").locale("th").format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    selected: [],
    search_dates: "",
    search_car: "",
    search_name: "",
    search_wastID: "",
    isMobile: false,
    search: "",
    wasteDocument: [],
    search_wastName: "",
    headers: [
      {
        text: "ลำดับ",
        align: "start",

        value: "index",
      },
      { text: "วันเก็บขน", value: "Time" },
      {
        text: "เลขที่เอกสาร ตช.",
        align: "start",
        sortable: true,
        value: "T_ID",
      },
      { text: "ชื่อแหล่งผลิต", value: "C_N" },
      { text: "รถเก็บขน", value: "CAR_NUMBER" },
      // { text: "รถเก็บถ่ายโอน", value: "CSI_CAR_N" },
      // { text: "รถเก็บขน", value: "CAR_NUMBER" },
      { text: "น้ำหนัก กก.", value: "W_W" },
      // { text: "รายละเอียด", value: "edit", width: "10%" },
      // { text: "พิมพ์", value: "Time", width: "10%" },
      // { text: "จัดการข้อมูล", value: "actions" },
    ],

    items: [],
    valueqr: "https://example.com",
    sizeqr: 100,
    last_mas: "",
  }),
  beforeCreate() {},
  created() {
    this.lsit_car();
    this.list_wastDocument("");
    this.list_wastName();
  },
  computed: {
    getindex_wasteDocument() {
      return this.wasteDocument.map((item, index) => ({
        ...item,
        index: index + 1,
        // create_date: moment(CREATE_DATE)
        //   .add(543, "years")
        //   .format("DD/MM/YYYY hh:mm:ss", true),
      }));
    },
    sumAll() {
      return this.wasteDocument != ""
        ? this.wasteDocument
            .map((item) => item.W_W)
            .reduce((acc, car) => acc + car)
        : 0;
    },
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x;
    },
    formatDate(data) {
      return moment(data).format("DD-MM-YYYY");
    },
  },

  methods: {
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.desserts.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    view_document(item) {
      this.waste_documentpdf(item);
    },
    print_document(item) {
      this.print_documentpdf(item);
    },
    testemit(item) {},
    async waste_documentpdf(item) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };

      pdfMake.createPdf(await waste_document(item)).open();
    },
    async print_documentpdf(item) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };

      pdfMake.createPdf(await print_document(item)).open();
    },
    clear_search() {
      this.search_dates = "";
      this.search_car = "";
      this.search_wastID = "";
      this.search_name = "";
      this.last_mas = "";
    },
    async search_search() {
      console.log( this.search_car );
      let s_d = " ";
      let s_d1 = " ";
      let s_d2 = " ";
      let s_c = " ";
      let s_w = " ";
      let s_n = "";
      let s_ct = "";
      if (
        this.search_dates &&
        this.search_car &&
        this.search_wastID &&
        this.search_name
      ) {
        console.log("1 2 3 4");
        // console.log(moment(this.search_dates[0]).format("YYYY-MM-DD"));
        // console.log(moment(this.search_dates[1]).format("YYYY-MM-DD"));
        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD");
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        s_w = this.search_wastID;
        s_n = this.search_name.CUSTOMER_NAME;
        this.last_mas = {
          s_d1s: s_d1,
          s_d2s: s_d2,
          s_cs: s_c,
          s_ws: s_w,
          s_n: s_n,
          s_ct: c_st,
        };
      } else if (
        !this.search_dates &&
        this.search_car &&
        this.search_wastID &&
        this.search_name
      ) {
        console.log(" 2 3 4");
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        s_w = this.search_wastID;
        s_n = this.search_name.CUSTOMER_NAME;
        this.last_mas = { s_cs: s_c, s_ws: s_w, s_n: s_n, s_ct: s_ct };
      } else if (
        this.search_dates &&
        !this.search_car &&
        this.search_wastID &&
        this.search_name
      ) {
        console.log("1  3 4");
        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD");

        s_w = this.search_wastID;
        s_n = this.search_name.CUSTOMER_NAME;
        this.last_mas = { s_d1s: s_d1, s_d2s: s_d2, s_ws: s_w, s_n: s_n };
      } else if (
        this.search_dates &&
        this.search_car &&
        !this.search_wastID &&
        this.search_name
      ) {
        console.log("1 2 4");

        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD");
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        s_n = this.search_name.CUSTOMER_NAME;
        this.last_mas = {
          s_d1s: s_d1,
          s_d2s: s_d2,
          s_cs: s_c,
          s_n: s_n,
          s_ct: s_ct,
        };
      } else if (
        this.search_dates &&
        this.search_car &&
        this.search_wastID &&
        !this.search_name
      ) {
        console.log("1 2 3");

        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD");
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        s_n = this.search_name.CUSTOMER_NAME;
        this.last_mas = {
          s_d1s: s_d1,
          s_d2s: s_d2,
          s_cs: s_c,
          s_n: s_n,
          s_ct: s_ct,
        };
      } else if (
        !this.search_dates &&
        !this.search_car &&
        this.search_wastID &&
        this.search_name
      ) {
        console.log("3 4");

        s_w = this.search_wastID;
        s_n = this.search_name.CUSTOMER_NAME;
        this.last_mas = { s_ws: s_w, s_n: s_n };
      } else if (
        !this.search_dates &&
        this.search_car &&
        !this.search_wastID &&
        this.search_name
      ) {
        console.log(" 2  4");

        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        s_n = this.search_name.CUSTOMER_NAME;
        this.last_mas = { s_cs: s_c, s_n: s_n, s_ct: s_ct };
      } else if (
        !this.search_dates &&
        this.search_car &&
        this.search_wastID &&
        !this.search_name
      ) {
        // console.log("not null 2");
        console.log(" 2 3 ");
        s_w = this.search_wastID;
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;

        this.last_mas = { s_cs: s_c, s_ws: s_w, s_ct: s_ct };
      } else if (
        this.search_dates &&
        !this.search_car &&
        !this.search_wastID &&
        this.search_name
      ) {
        console.log("1 4");
        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD");
        s_n = this.search_name.CUSTOMER_NAME;
        this.last_mas = { s_d1s: s_d1, s_d2s: s_d2, s_n: s_n };
      } else if (
        this.search_dates &&
        !this.search_car &&
        this.search_wastID &&
        !this.search_name
      ) {
        console.log("1 3 ");
        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD");
        s_w = this.search_wastID;
        this.last_mas = { s_d1s: s_d1, s_d2s: s_d2, s_ws: s_w };
      } else if (
        this.search_dates &&
        this.search_car &&
        !this.search_wastID &&
        !this.search_name
      ) {
        console.log("1 2 ");
        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD");
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        this.last_mas = { s_d1s: s_d1, s_d2s: s_d2, s_cs: s_c, s_ct: s_ct };
      } else if (
        this.search_dates &&
        !this.search_car &&
        !this.search_wastID &&
        !this.search_name
      ) {
        console.log("1 ");
        s_d1 = moment(this.search_dates[0]).format("YYYY-MM-DD");
        s_d2 = moment(this.search_dates[1]).format("YYYY-MM-DD");
        this.last_mas = { s_d1s: s_d1, s_d2s: s_d2 };
      } else if (
        !this.search_dates &&
        this.search_car &&
        !this.search_wastID &&
        !this.search_name
      ) {
        console.log("2 ");
        s_c = this.search_car.CAR_NUMBER;
        s_ct = this.search_car.CAR_TYPE;
        this.last_mas = { s_cs: s_c, s_ct: s_ct };
      } else if (
        !this.search_dates &&
        !this.search_car &&
        this.search_wastID &&
        !this.search_name
      ) {
        console.log("3 ");

        s_w = this.search_wastID;

        this.last_mas = { s_ws: s_w };
      } else if (
        !this.search_dates &&
        !this.search_car &&
        !this.search_wastID &&
        this.search_name
      ) {
        console.log("4 ");

        s_n = this.search_name.CUSTOMER_NAME;
        this.last_mas = { s_n: s_n };
      } else {
        // console.log("null all ");
        this.last_mas = { nulls: "y" };
      }
      console.log(this.last_mas);
      await this.list_wastDocument(this.last_mas);
    },
    lsit_car() {
      this.$token_api
        .get("/search_car")
        .then((res) => {
          console.log(res.data.data);
          this.carItem = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async list_wastDocument(item) {
      this.$token_api
        .post("/search_wastDocument", item)
        .then((res) => {
          this.wasteDocument = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    list_wastName() {
      this.$token_api
        .get("/search_wastDocumentName")
        .then((res) => {
          //console.log(res.data.data);
          this.search_wastName = res.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    sumField(key) {
      return this.wasteDocument.reduce((a, b) => a + (b[key] || 0), 0);
    },
    initialize() {
      this.list_wastDocument("");
    },
    timeTH(date) {
      return date
        ? moment(date).add(543, "year").locale("th").format("LL")
        : "";
    },
    goLinkReportDoc(item) {
      window.open(`${this.$global_link}/l-Doc/${item.T_ID}`);
      // window.open("http://localhost:8080/l-Doc/" + item.T_ID, "_blank");
      // ${this.$global_link}${_from.path}
    },
    reportPDF() {
      // console.log(this.search_car.CAR_NUMBER)
      // console.log(this.wasteDocument);
      if(this.wasteDocument!=""){
 this.ReportPDF(this.wasteDocument,this.search_car.CAR_NUMBER);
      }else{
         this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาค้นหาข้อมูลที่ต้องการรายงาน`,
          timer: 3000,
        });
      }
     
    },
    async ReportPDF(item,carName) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      }; 
      pdfMake.createPdf(await WwasteReportPDF(item,carName,this.$AppName)).open();
    },
    linktoPublic() {
      console.log("click linktoPublic");
        console.log(this.last_mas);

      if (this.last_mas != "") {
        let s_cs = this.last_mas.s_cs ? this.last_mas.s_cs : null;
        let s_d1s = this.last_mas.s_d1s ? this.last_mas.s_d1s : null;
        let s_d2s = this.last_mas.s_d2s ? this.last_mas.s_d2s : null;
        let s_n = this.last_mas.s_n ? this.last_mas.s_n : null;
        let s_ws = this.last_mas.s_ws ? this.last_mas.s_ws : null;
        let nulls = null;
        if (!s_cs && !s_d1s && !s_d2s && !s_n && !s_ws) {
          nulls = "y";
        }
        let ns_cs = s_cs != null ? s_cs.replace("#", "%23") : "null";

        //console.log(s_cs.replaceAll("#", "%23"));
        let searh_url = `${ns_cs}&${s_d1s}&${s_d2s}&${s_n}&${s_ws}&${nulls}`;
        // console.log(s_cs);
        window.open(
          `${this.$global_link}/waste-report-plublic-link/${searh_url}`,
          "_blank"
        );
      } else {
        this.$swal({
          title: "ไม่พบข้อมูล",
          icon: "warning",
          text: `กรุณาค้นหาข้อมูลที่ต้องการส่งออก`,
          timer: 3000,
        });
      }
    },
  },
};
</script>
